'use strict';

require('theme/js/index');
require('./b2bregistration');
